import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';

import {LEAF_TYPE_TO_VALUE_INPUT} from './internals/BenchlingTypeValueInputConstants';

const SUPPORTED_LEAF_TYPES = Object.keys(LEAF_TYPE_TO_VALUE_INPUT).filter(
  (leafType) => LEAF_TYPE_TO_VALUE_INPUT[leafType as LeafType] != null
);

export function leafTypeHasBenchlingTypeValueInput(leafType: LeafType): boolean {
  return ([...SUPPORTED_LEAF_TYPES] as Array<LeafType>).includes(leafType);
}
